import { c as _c } from "react/compiler-runtime";
import { useSnapshot } from "valtio";
import { FlowActions, FlowState } from "../../stores/flowStore";
export function useAllActionsCompleted() {
  const $ = _c(2);
  const {
    allActionsCompleted
  } = useSnapshot(FlowState);
  let t0;
  if ($[0] !== allActionsCompleted) {
    t0 = [allActionsCompleted, FlowActions.setAllActionsCompleted];
    $[0] = allActionsCompleted;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}